const rutasAmbiente = [
  //Nubes
  {
    name: "textura_nubes",
    type: "texture",
    path: "texturas/ambiente/nubes.webp",
  },
  //Satelital
  {
    name: "textura_satelital",
    type: "texture",
    path: "texturas/ambiente/satelital.webp",
  },
  /*{
    name: "textura_satelital_zoom",
    type: "texture",
    path: "texturas/ambiente/satelital_zoom.webp",
  },
*/
  //Elevacion
  {
    name: "textura_terreno_elevacion",
    type: "texture",
    path: "texturas/ambiente/terreno_elevacion.jpg",
  },
];

export default rutasAmbiente;
